import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import InputElement         from 'react-input-mask';
import FieldError           from '../../Fragments/FieldError';
import moment               from 'moment';

let Validation = require('../../Managers/Validation.js');
let Quote = require('../../Managers/Quote');
let dateFormat = 'YYYY-MM-DD';

class FullDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            isValid: false,
            activeValue : props.defaultValue ? props.defaultValue : '',
            dateStatus: 1,
        };
    }

    componentWillMount() {
        if (!window.uorn(this.props.defaultValue)) {
            let dateChunks = this.props.defaultValue.split('-');
            this.setState({
                date : parseInt(dateChunks[2]),
                month : parseInt(dateChunks[1]),
                year : dateChunks[0],
            });
        } else {
            this.setState({
                date : '0',
                month : '0',
                year : null,
            });
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(field) {
        let day = ('0' + document.getElementById(this.props.fieldName + '-day').value).slice(-2);
        let month = ('0' + document.getElementById(this.props.fieldName + '-month').value).slice(-2);
        let year = document.getElementById(this.props.fieldName + '-year').value;
        // Don't fire any kind of validation unless a year has been provided in
        // the requested format
        let enteredDate = null;
        if (year !== '' && year.length === 4 && String(day) !== '00' && String(month) !== '00') {
            enteredDate = year + '-' + month + '-' + day;
        }
        let concatonatedDate = year + '-' + month + '-' + day;

        let dataValidation = this.props.dataValidation;

        const activeValue = moment(enteredDate).format(dateFormat);

        if (this.props.dateType === 'dob') {
            // if they're editing date or month and there's no value for the
            // year, but there IS a value for the whole thing, do nothing - it
            // means they're still filling the fields in.
            let validation = null;
            if (!((field === String('date') || field === String('month')) && window.uornorb(year) && !window.uornorb(concatonatedDate))) {
                validation = Validation.validate(dataValidation, enteredDate)[0];
            } else {
                validation = Validation.validObject();
            }

            Quote.set(this.props.storageKey, moment(enteredDate).format(dateFormat), this.props.source);
            Quote.setAnswer(this.props.storageKey, moment(enteredDate).format(dateFormat));

            this.setState(Object.assign({}, validation, {
                activeValue
            }), () => {
                this.props.isValid(validation.isValid, this.state.activeValue);
            });
        }

        if (this.props.dateType === 'full') {
            let validation = Validation.validate(dataValidation, enteredDate)[0];

            if (field === "date" || field === "month") {
                this.props.isValid(true);
            } else {
                Quote.set(this.props.storageKey, moment(enteredDate).format(dateFormat), this.props.source);
                Quote.setAnswer(this.props.storageKey, moment(enteredDate).format(dateFormat));

                this.setState(Object.assign({}, validation, {
                    activeValue
                }), () => {
                    this.props.isValid(validation.isValid, this.state.activeValue);
                });
            }
        }

        if (this.props.dateType === 'start-date') {
            // Flag the date as being 'future' if it is after today's date
            if (moment(enteredDate).isAfter(moment(), 'day')) {
                Quote.set('employmentStartDate', '3', this.props.source);
            }
        }

        // If we're looking for an end date, it cannot be in the past.
        if (this.props.dateType === 'end-date') {
            let validation = Validation.validate(dataValidation, enteredDate, 'too_soon')[0];

            this.setState(validation, () => {
                this.props.isValid(validation.isValid);
            });

            Quote.set(this.props.storageKey, moment(enteredDate).format(dateFormat), this.props.source);

            this.setState({
                activeValue
            });
        }
    }

    render() {
        return (
            <div>
                <div className="question-input">
                    <div className="row-3 constrained-row">
                        <div className="column">
                            <select
                                id={this.props.fieldName + '-day'}
                                className="form-control"
                                onBlur={this.handleValidation.bind(this, "date")}
                                defaultValue={this.state.date}
                                placeholder="Day"
                            >
                                <option value={0}>{this.props.defaultDayText}</option>
                                {Array.apply(0, Array(31)).map(function (x, i) {
                                    let day = String(i + 1);
                                    return <option key={day} value={day}>{day}</option>;
                                })}
                            </select>
                        </div>
                        <div className="column">
                            <select
                                id={this.props.fieldName + '-month'}
                                className="form-control"
                                onBlur={this.handleValidation.bind(this, "month")}
                                defaultValue={this.state.month}
                                placeholder="Month"
                            >
                                <option value={0}>{this.props.defaultMonthText}</option>
                                {Array.apply(0, Array(12)).map(function (x, i) {
                                    let month = String(i + 1);
                                    return <option key={month} value={month}>{moment().month(i).format('MMM')}</option>;
                                })}
                            </select>
                        </div>
                        <div className="column">
                            <InputElement
                                id={this.props.fieldName + '-year'}
                                className="form-control"
                                placeholder="E.g. 1982"
                                mask="9999"
                                maskChar={null}
                                onBlur={this.handleValidation.bind(this, "year")}
                                defaultValue={this.state.year}
                            />
                            <input
                                type="hidden"
                                name={this.props.fieldName}
                                id={this.props.fieldName}
                                value={this.state.fullDate}
                                data-validation={this.props.dataValidation}
                            />
                        </div>
                    </div>
                </div>
                {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}
            </div>
        );
    }
}

FullDate.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string.isRequired,
    loadCachedValue:    PropTypes.bool.isRequired,
    dateType:           PropTypes.string.isRequired,
    defaultDayText:     PropTypes.string,
    defaultMonthText:   PropTypes.string,
    defaultValue:       PropTypes.string,
    dataValidation:     PropTypes.string,
    isValid:            PropTypes.func,
    source:             PropTypes.string,
};

FullDate.defaultProps = {
    defaultDayText: 'DD',
    defaultMonthText: 'Month',
    defaultValue: null,
};

export default FullDate;


// WEBPACK FOOTER //
// ./src/components/Fields/Dates/FullDate.js